import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ArrayService {
  constructor() {}
  /**
   *  Checks if the given array is null or empty
   */
  isNullOrEmpty<T>(array: T[] | null | undefined): boolean {
    return !array || array.length === 0;
  }
}
